import { useTranslation } from 'react-i18next';
import { useConsent } from '../context/ConsentContext';
import { useEffect, useState } from 'react';

export default function CookieManagerModal() {
  const { t } = useTranslation();
  const { consent, setConsent, closeManager, managerOpen, acceptAll, rejectAll } = useConsent();
  const [analytics, setAnalytics] = useState<boolean>(false);
  const [marketing, setMarketing] = useState<boolean>(false);

  useEffect(() => {
    if (consent) {
      setAnalytics(consent.analytics);
      setMarketing(consent.marketing);
    }
  }, [consent, managerOpen]);

  if (!managerOpen) return null;

  return (
    <div className="fixed inset-0 z-[110] flex min-h-screen items-center justify-center bg-black/70 backdrop-blur-sm p-4 sm:p-6" role="dialog" aria-modal="true" aria-labelledby="cookie-manager-title">
      <div className="w-full max-w-md bg-gray-900 rounded-lg sm:rounded-xl shadow-2xl border border-pink-600/20">
        <div className="flex items-center justify-between px-5 sm:px-6 py-4 border-b border-gray-800">
          <h3 id="cookie-manager-title" className="text-lg font-semibold text-white">{t('consent.manageTitle')}</h3>
          <button onClick={closeManager} className="text-gray-400 hover:text-white px-2 py-1 rounded">✕</button>
        </div>
        <div className="p-5 sm:p-6 space-y-4 text-gray-200">
          <div className="space-y-2">
            <div className="flex items-center justify-between">
              <div>
                <div className="font-medium">{t('consent.analytics')}</div>
                <div className="text-xs text-gray-400">{t('consent.analyticsDesc')}</div>
              </div>
              <input type="checkbox" checked={analytics} onChange={(e) => setAnalytics(e.target.checked)} className="h-4 w-4" />
            </div>
            <div className="flex items-center justify-between">
              <div>
                <div className="font-medium">{t('consent.marketing')}</div>
                <div className="text-xs text-gray-400">{t('consent.marketingDesc')}</div>
              </div>
              <input type="checkbox" checked={marketing} onChange={(e) => setMarketing(e.target.checked)} className="h-4 w-4" />
            </div>
          </div>
          <div className="flex flex-col sm:flex-row gap-2 sm:gap-3">
            <button onClick={rejectAll} className="px-4 py-2 rounded-md border border-gray-700 hover:border-gray-600 text-gray-200">{t('consent.rejectAll')}</button>
            <button onClick={() => setConsent({ necessary: true, analytics, marketing })} className="px-4 py-2 rounded-md border border-pink-600/40 text-pink-300 hover:text-white hover:border-pink-500">{t('consent.save')}</button>
            <button onClick={acceptAll} className="px-4 py-2 rounded-md bg-pink-600 hover:bg-pink-700 text-white font-semibold">{t('consent.acceptAll')}</button>
          </div>
        </div>
      </div>
    </div>
  );
}


